<template>
    <div class="cmpDownload">
        <span class="download_text" @click.stop="handleDownloadListShow">
            <el-tooltip effect="dark" content="导出列表" placement="left-start">
                <i :class="['cmp-icon-download-list', 'download_icon', getDownloadStatus ? 'download_animation' : '']">
                    <!-- <sub class="count_downloading">{{downloadingCount}}</sub> -->
                </i>
            </el-tooltip>
            <!-- <i class="cmp-icon-download-list download_icon"></i> -->
        </span>
        <transition name="fade">
            <div class="download_list_wrap" v-if="showDownloadListFlag" v-clickoutside="handleClickOutside">
                <div class="fix_height" v-if="downloadList && downloadList.length">
                    <ul class="download_list">
                        <li class="download_item" v-for="item in downloadList" :key="item.id">
                            <div class="download_item-left">
                                <span class="download_title">{{item.s3_key ? item.s3_key : '未知'}}
                                    <i class="el-icon-warning-outline" v-if="+item.status === 32"></i>
                                </span>
                                <span class="download_status">{{renderStatus(item.status)}}
                                    <i class="el-icon-loading" v-if="+item.status === 0 || +item.status === 2 || +item.status === 4"></i>
                                </span>
                            </div>
                            <el-button v-if="item.download_link" type="text" @click="handleDownload(item.download_link)">下载</el-button>
                            <i v-else-if="item.status >= 8" class="cmp-icon-close-btn downloadDelete" @click="handleDelete(item.id)"></i>
                        </li>
                    </ul>
                    <div class="download_item clear_button">
                        <el-button type="text" @click="clearAll">清空列表</el-button>
                    </div>
                </div>
                <p class="empty_data" v-else>暂无数据</p>
            </div>
        </transition>
    </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex';
import api from '@/modules/cmp/constants/api';
export default {
    name: 'cmpDownload',
    data() {
        return {
            showDownloadListFlag: false,
            downloadList: [],
            refreshTimer: undefined
        };
    },
    components: {},
    watch: {
        completeCount: {
            handler(newVal, oldVal) {
                if ((oldVal && newVal > oldVal) || (oldVal === 0 && newVal === 1)) {
                    this.$message.success('您的导出任务已完成');
                }
            }
        },
        getDownloadStatus: {
            handler(val) {
                if (val) {
                    this.getDataJobList();
                    this.getDownloadListRegualar();
                    // this.setDownloadStatus(false);
                    let timer = setTimeout(() => {
                        this.setDownloadStatus(false);
                        clearTimeout(timer);
                    }, 2500);
                }
            }
        }
    },
    computed: {
        ...mapGetters({
            getDownloadList: 'getDownloadList',
            getDownloadStatus: 'getDownloadStatus'
        }),
        completeCount() {
            if (this.downloadList && this.downloadList.length) {
                let list = this.downloadList.filter(item => item.status >= 8).map(item => item.download_link);
                return list.length;
            }
        },
        downloadingCount() {
            if (this.downloadList && this.downloadList.length) {
                let list1 = this.downloadList.filter(item => +item.status < 8).map(item => item.id);
                // console.log(list1.length, list1);
                return list1.length;
            }
        }
    },
    created() {
        this.getDataJobList();
    },
    mounted() {
        this.getDownloadListRegualar();
    },
    beforeDestroy() {
        this.refreshTimer && clearInterval(this.refreshTimer);
    },
    methods: {
        ...mapMutations({
            setDownloadList: 'setDownloadList',
            setDownloadStatus: 'setDownloadStatus'
        }),
        handleDownloadListShow() {
            this.showDownloadListFlag = !this.showDownloadListFlag;
        },
        getDataJobList() {
            this.$request({
                url: api.getDataJobList,
                method: 'get',
                contentType: 'application/json; utf8',
                success: (res) => {
                    this.downloadList = res.jobs && res.jobs.length ? res.jobs.reverse() : [];
                    if (!res || !res.jobs || !res.jobs.length) {
                        this.refreshTimer && clearInterval(this.refreshTimer);
                    } else {
                        let list = this.downloadList.filter(item => +item.status < 8);
                        if (!list || !list.length) {
                            this.refreshTimer && clearInterval(this.refreshTimer);
                        }
                    }
                },
                error: () => {
                    this.refreshTimer && clearInterval(this.refreshTimer);
                }
            });
        },
        getDownloadListRegualar() {
            this.refreshTimer && clearInterval(this.refreshTimer);
            this.refreshTimer = setInterval(() => {
                this.getDataJobList();
            }, 15000);
        },
        handleDownload(link) {
            if (link) {
                window.open(link);
            }
        },
        handleDelete(id, count) {
            this.$request({
                url: api.deleteDataJob,
                method: 'post',
                qs: true,
                success: (res) => {
                    if (!count) {
                        this.getDataJobList();
                        this.$message.success('删除成功');
                    }
                },
                error: () => {}
            },
            {
                job_id: id
            }
            );
        },
        clearAll() {
            this.refreshTimer && clearInterval(this.refreshTimer);
            let ids = [];
            if (!this.downloadList || !this.downloadList.length) return false;
            ids = this.downloadList.filter(item => item.status >= 8).map(item => item.id);
            if (ids && ids.length) {
                ids.forEach((id, index) => {
                    this.handleDelete(id, (ids.length - index - 1));
                });
            }
            if (this.downloadList && this.downloadList.length) {
                this.getDownloadListRegualar();
            }
        },
        renderStatus(status) {
            let text = '';
            switch (+status) {
                case 8:
                    text = '已完成';
                    break;
                case 4:
                case 2:
                case 0:
                    text = '导出中';
                    break;
                // case 0:
                //     text = '开始导出';
                //     break;
                case 16:
                    text = '已删除';
                    break;
                case 32:
                    text = '导出超时';
                    break;
                case 64:
                    text = '数据为空';
                    break;
                default:
                    text = status;
                    break;
            }
            return text;
        },
        handleClickOutside() {
            if (this.showDownloadListFlag) {
                this.showDownloadListFlag = false;
            }
        }
    }
};
</script>

<style scoped lang="scss">
.cmpDownload {
    position: relative;
    height: vw(50);
    line-height: vw(50);
    .download_text {
        color: $main-font-color;
        font-weight: 700;
        font-size: vw(12);
        line-height: vw(50);
        display: inline-block;
        cursor: pointer;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        .download_icon {
            margin-top: vw(15);
            width: vw(18);
            height: vw(18);
            display: inline-block;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: bottom center;
            // position: relative;
            // .count_downloading {
            //     background-color: #FF1C00;
            //     position: absolute;
            //     width: vw(12);
            //     height: vw(12);
            //     border-radius: vw(10);
            //     line-height: vw(12);
            //     text-align: center;
            //     color: #fff;
            //     font-style: normal;
            //     right: 0;
            //     top: vw(-5);
            // }
        }
        .download_animation {
            animation: scaleDownload 2.5s ease-in-out;
        }
        @keyframes scaleDownload {
            0% {
                transform: scale(1);
            }
            25% {
                transform: scale(2);
            }
            50% {
                transform: scale(1);
            }
            75% {
                transform: scale(2);
            }
            100% {
                transform: scale(1);
            }
        }
    }
    .download_list_wrap {
        position: absolute;
        top: vw(45);
        z-index: 999;
        width: vw(500);
        right: 0;
        background: #fff;
        border: 1px solid #EAECF0;
        box-shadow: 0 vw(2) vw(10) 0 rgba(107,119,153,0.30);
        border-radius: vw(3);
        padding: vw(10) 0 vw(60);
        box-sizing: border-box;
        overflow: hidden;
        max-height: vw(500);
        .fix_height {
            overflow-y: auto;
            max-height: vw(500);
        }
        .empty_data {
            text-align: center;
            padding: vw(30) 0 0;
            font-family: PingFangSC-Regular;
            font-size: 13px;
            color: #53575B;
            letter-spacing: 0;
            line-height: 13px;
        }
        .download_list {
            overflow-y: auto;
            padding-bottom: vw(60);
            .download_item {
                margin: 0 vw(20);
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                height: vw(50);
                border-bottom: 1px solid $border-color;
                &:last-of-type {
                    border-bottom: none;
                }
                .download_item-left {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: space-between;
                    line-height: 1;
                    .download_title {
                        margin-bottom: vw(5);
                        font-size: vw(13);
                        .el-icon-warning-outline {
                            color: #FF1C00;
                            font-size: vw(16);
                            margin-left: vw(5);
                            font-weight: 700;
                        }
                    }
                    .download_status {
                        font-size: vw(12);
                        font-weight: normal;
                        color: $sub-font-color;
                    }
                }
                .el-button {
                    font-size: vw(12);
                }
                .downloadDelete {
                    width: vw(10);
                    height: vw(10);
                    cursor: pointer;
                }
            }
        }
        .clear_button {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            background: #f8fafc;
            padding: 0 vw(20);
            text-align: left;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/modules/cmp/components/cmpDownload.vue